export const formatPrice = (price?: number | null, currency?: string | null) => {
    if (price == null) return '-';
    const currencyCode = currency || 'SEK';
    return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
    }).format(price);
};
